import React from "react";

function CompletionByPath({ rows, loading }) {
  const list = (rows || []).slice(0, 6);

  return (
    <div className="dv-card">
      <div className="dv-head">
        <div><h3>Completion by path</h3></div>
        <div className="sp" />
        <a className="dv-link" href="#/paths">All paths →</a>
      </div>
      {loading && !rows ? (
        <div className="dv-empty">Loading…</div>
      ) : list.length === 0 ? (
        <div className="dv-empty">No path completion data in this period yet.</div>
      ) : (
        list.map((r) => (
          <div className="bp" key={r.id}>
            <div className="top"><span className="s">{r.name}</span><span className="v">{r.completion_rate}%</span></div>
            <div className="track"><i style={{ width: `${Math.min(r.completion_rate, 100)}%` }} /></div>
          </div>
        ))
      )}
    </div>
  );
}

export default CompletionByPath;
